module.exports = __webpack_public_path__ + "PowerPoint.svg";